var React = require('react');

function Information (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.30766 6.8344C3.58179 6.8344 4.61536 7.95472 4.61536 9.332V17.5024C4.61536 18.8821 3.58173 20 2.30766 20C1.0336 20 -2.77527e-05 18.882 -2.77527e-05 17.5024V9.332C-2.77527e-05 7.95388 1.0336 6.8344 2.30766 6.8344V6.8344ZM2.30766 0C3.58179 0 4.61536 1.01328 4.61536 2.264V2.814C4.61536 4.064 3.58173 5.078 2.30766 5.078C1.0336 5.078 -2.77527e-05 4.06394 -2.77527e-05 2.814V2.264C-2.77527e-05 1.01322 1.0336 0 2.30766 0Z","fill":"#1943EF"}));
}

Information.defaultProps = {"width":"5","height":"20","viewBox":"0 0 5 20","fill":"none"};

module.exports = Information;

Information.default = Information;
